import { getToken, setToken, removeTokenCookie } from '../utils/cookieUtils';

export const authManager = {
  login: (userData, token) => {
    // Store token in cookies only
    setToken(token);
    localStorage.setItem('logged_user_id', userData.id || '');
    localStorage.setItem('role', userData.role || '');

    if (userData) {
      localStorage.setItem('user_data', JSON.stringify(userData));
    }

    localStorage.setItem('isAuthenticated', 'true');
  },

  logout: () => {
    // ❌ DO NOT clear everything
    // localStorage.clear();

    // ✅ Remove ONLY auth keys
    removeTokenCookie();
    localStorage.removeItem('logged_user_id');
    localStorage.removeItem('role');
    localStorage.removeItem('user_data');

    localStorage.setItem('isAuthenticated', 'false');
  },

  isLoggedIn: () => {
    return (
      localStorage.getItem('isAuthenticated') === 'true' &&
      getToken()
    );
  },

  getRole: () => {
    return localStorage.getItem('role');
  },

  getUserData: () => {
    const userData = localStorage.getItem('user_data');
    if (userData) {
      try {
        return JSON.parse(userData);
      } catch {
        return null;
      }
    }
    return null;
  },

  getToken: () => {
    return getToken();
  },
};